"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// packages/remirror__extension-text-highlight/src/index.ts
var src_exports = {};
__export(src_exports, {
  TextHighlightExtension: () => TextHighlightExtension
});
module.exports = __toCommonJS(src_exports);

// packages/remirror__extension-text-highlight/src/text-highlight-extension.ts
var import_core = require("@remirror/core");
var import_extension_text_color = require("@remirror/extension-text-color");
var import_messages = require("@remirror/messages");
var setTextHighlightOptions = {
  icon: "markPenLine",
  description: ({ t }) => t(import_messages.ExtensionTextHighlightMessages.DESCRIPTION),
  label: ({ t }) => t(import_messages.ExtensionTextHighlightMessages.LABEL)
};
var TEXT_HIGHLIGHT_ATTRIBUTE = "data-text-highlight-mark";
var TextHighlightExtension = class extends import_core.MarkExtension {
  get name() {
    return "textHighlight";
  }
  createTags() {
    return [import_core.ExtensionTag.FormattingMark, import_core.ExtensionTag.FontStyle];
  }
  createMarkSpec(extra, override) {
    return {
      ...override,
      attrs: {
        ...extra.defaults(),
        highlight: { default: this.options.defaultHighlight }
      },
      parseDOM: [
        {
          tag: `span[${TEXT_HIGHLIGHT_ATTRIBUTE}]`,
          getAttrs: (dom) => {
            if (!(0, import_core.isElementDomNode)(dom)) {
              return null;
            }
            const highlight = dom.getAttribute(TEXT_HIGHLIGHT_ATTRIBUTE);
            if (!highlight) {
              return null;
            }
            return { ...extra.parse(dom), highlight };
          }
        },
        {
          tag: `span[${TEXT_HIGHLIGHT_ATTRIBUTE}]`,
          getAttrs: (dom) => {
            if (!(0, import_core.isElementDomNode)(dom)) {
              return null;
            }
            const highlight = dom.getAttribute(TEXT_HIGHLIGHT_ATTRIBUTE);
            if (!highlight) {
              return null;
            }
            return { ...extra.parse(dom), highlight };
          }
        },
        {
          // Get the color from the css style property. This is useful for pasted content.
          style: "background-color",
          priority: import_core.ExtensionPriority.Low,
          getAttrs: (highlight) => {
            if (!(0, import_core.isString)(highlight)) {
              return null;
            }
            return { highlight };
          }
        },
        ...override.parseDOM ?? []
      ],
      toDOM: (mark) => {
        const { highlight, ...other } = (0, import_core.omitExtraAttributes)(
          mark.attrs,
          extra
        );
        const extraAttrs = extra.dom(mark);
        let style = extraAttrs.style;
        if (highlight) {
          style = (0, import_core.joinStyles)({ backgroundColor: highlight }, style);
        }
        return [
          "mark",
          { ...other, ...extraAttrs, style, [TEXT_HIGHLIGHT_ATTRIBUTE]: highlight },
          0
        ];
      }
    };
  }
  setTextHighlight(highlight, options) {
    return this.store.commands.applyMark.original(this.type, { highlight }, options?.selection);
  }
  removeTextHighlight(options) {
    return this.store.commands.removeMark.original({ type: this.type, ...options, expand: true });
  }
};
__decorateClass([
  (0, import_core.command)(setTextHighlightOptions)
], TextHighlightExtension.prototype, "setTextHighlight", 1);
__decorateClass([
  (0, import_core.command)()
], TextHighlightExtension.prototype, "removeTextHighlight", 1);
TextHighlightExtension = __decorateClass([
  (0, import_core.extension)({
    defaultOptions: {
      defaultHighlight: "",
      palette: import_extension_text_color.palette
    },
    staticKeys: ["defaultHighlight"]
  })
], TextHighlightExtension);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  TextHighlightExtension
});
